/* eslint-disable */

import { useMemo, useState } from 'react';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayIcon from '@mui/icons-material/Replay';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useTranslation } from 'react-i18next';
import { ConfigCombinations } from 'components/dialog/combination_rule/ConfigCombinations';
import { ConsiderOvertime } from 'components/dialog/combination_rule/ConsiderOvertime';
import { AddCombinations } from 'components/dialog/combination_rule/AddCombinations';
import { InfoCombinations } from 'components/dialog/combination_rule/InfoCombinations';
import { EditCombinations } from 'components/dialog/combination_rule/EditCombinations';
import { DuplicateCombinations } from 'components/dialog/combination_rule/DuplicateCombinations';
import { DeleteCombination } from 'components/dialog/combination_rule/DeleteCombination';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import { buildSettingsBasePath, buildSettingsCrudPath, parseSettingsCrudRoute } from 'utils/settingsCrudRouting';

export const SubMenu = (props) => {
    const { contextMenu, setContextMenu, selectedRow, reloading, rows } = props;
    const location = useLocation();
    const navigate = useNavigate();

    const { t } = useTranslation();

    const [openDuplicate, setOpenDuplicate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openAsignar, setOpenAsignar] = useState(false);
    const [openTenerEnCuenta, setOpenTenerEnCuenta] = useState(false);
    const basePath = buildSettingsBasePath('combinations');
    const modalRoute = useMemo(() => parseSettingsCrudRoute(location.pathname, 'combinations'), [location.pathname]);
    const openAdd = modalRoute.action === 'add';
    const openEdit = modalRoute.action === 'update' && modalRoute.id !== null;
    const openShow = modalRoute.action === 'detail' && modalRoute.id !== null;

    const selectedRowFromRoute = useMemo(() => {
        if (modalRoute.id === null) return null;
        return rows.find((row) => Number(row.id) === modalRoute.id) || null;
    }, [rows, modalRoute.id]);
    const selectedRowForRoute = selectedRowFromRoute || selectedRow[0];

    const closeRouteModal = () => {
        navigate(basePath);
    };
    const rowsSelected = selectedRow[0];
    let configs =
        rowsSelected?.overtime_rules?.length +
            rowsSelected?.zones?.length +
            rowsSelected?.schedule_desviation_rules?.length >
        1
            ? false
            : true;

    const options = [
        {
            name: t('settings.combinations.table.submenu.add'),
            icon: <AddIcon />,
            click: () => {
                navigate(buildSettingsCrudPath('combinations', 'add'));
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: false,
            selected: false,
            onlyOne: false,
            hidden: JSON.parse(localStorage.getItem('permissions')).find(
                (permision) => permision === 'timekeeper.CreateCombinationRule',
            )
                ? false
                : true,
        },
        {
            name: t('settings.combinations.table.submenu.details'),
            icon: <VisibilityIcon />,
            click: () => {
                const current = selectedRow[0];
                if (!current?.id) return;
                navigate(buildSettingsCrudPath('combinations', 'detail', current.id));
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: selectedRow.length <= 0 ? true : false,
            selected: true,
            onlyOne: false,
            hidden:
                selectedRow.length <= 0 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.CombinationRulesById',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.edit'),
            icon: <EditIcon />,
            click: () => {
                const current = selectedRow[0];
                if (!current?.id) return;
                navigate(buildSettingsCrudPath('combinations', 'update', current.id));
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: selectedRow.length === 1 ? false : true,
            selected: false,
            onlyOne: true,
            hidden:
                selectedRow.length !== 1 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.UpdateCombinationRule',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.combination_configuration'),
            icon: <ChecklistRtlIcon />,
            click: () => {
                setOpenAsignar(true);
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: configs,
            selected: false,
            onlyOne: true,
            hidden:
                selectedRow.length !== 1 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.UpdateCombinationOfCombinationRule',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.consider_overtime'),
            icon: <AccessTimeIcon />,
            click: () => {
                setOpenTenerEnCuenta(true);
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: configs,
            selected: false,
            onlyOne: true,
            hidden:
                selectedRow.length !== 1 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.SaveOvertimeAssign',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.duplicate'),
            icon: <ContentCopyIcon />,
            click: () => {
                setOpenDuplicate(true);
                setContextMenu(null);
            },
            color: '',
            divider: false,
            disabled: selectedRow.length === 1 ? false : true,
            selected: false,
            onlyOne: true,
            hidden:
                selectedRow.length !== 1 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.CreateCombinationRule',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.delete'),
            icon: <DeleteIcon color="error" />,
            click: () => {
                setOpenDelete(true);
                setContextMenu(null);
            },
            color: 'error',
            divider: false,
            disabled: /* selectedRow.length <= 0 ? true : false, */ true,
            selected: true,
            onlyOne: false,
            hidden:
                selectedRow.length === 0 ||
                !JSON.parse(localStorage.getItem('permissions')).find(
                    (permision) => permision === 'timekeeper.DeleteCombinationRule',
                )
                    ? true
                    : false,
        },
        {
            name: t('settings.combinations.table.submenu.refresh'),
            icon: <ReplayIcon />,
            click: () => {
                reloading();
                setContextMenu(null);
            },
            color: '',
            divider: true,
            disabled: false,
            selected: false,
            onlyOne: false,
            hidden: false,
        },
    ];

    return (
        <>
            <Menu
                open={contextMenu ? true : false}
                onClose={() => setContextMenu(null)}
                anchorReference="anchorPosition"
                anchorPosition={contextMenu ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
                sx={{ boxShadow: 'none' }}
            >
                {options.map((option, index) => (
                    <div key={index}>
                        {option.divider ? <Divider /> : null}

                        {option.hidden === false && (
                            <MenuItem onClick={option.click} disabled={option.disabled}>
                                <ListItemIcon>{option.icon}</ListItemIcon>
                                <ListItemText
                                    primary={option.name}
                                    slotProps={{
                                        primary: { color: option.color },
                                    }}
                                />
                            </MenuItem>
                        )}
                    </div>
                ))}
            </Menu>

            <AddCombinations open={openAdd} setOpenAdd={(nextOpen) => { if (!nextOpen) closeRouteModal(); }} rows={rows} reloading={reloading} />
            <InfoCombinations open={openShow} setOpenShow={(nextOpen) => { if (!nextOpen) closeRouteModal(); }} select={selectedRowForRoute ? [selectedRowForRoute] : selectedRow} />
            <EditCombinations
                open={openEdit}
                setOpenEdit={(nextOpen) => { if (!nextOpen) closeRouteModal(); }}
                rows={rows}
                select={selectedRowForRoute}
                reloading={reloading}
            />
            <ConfigCombinations
                open={openAsignar}
                setOpenAsignar={setOpenAsignar}
                rows={rows}
                select={selectedRow[0]}
                reloading={reloading}
            />
            <DuplicateCombinations
                open={openDuplicate}
                setOpenDuplicate={setOpenDuplicate}
                rows={rows}
                select={selectedRow[0]}
                reloading={reloading}
            />
            <ConsiderOvertime
                open={openTenerEnCuenta}
                setOpenTenerEnCuenta={setOpenTenerEnCuenta}
                rows={rows}
                select={selectedRow[0]}
                reloading={reloading}
            />
            <DeleteCombination
                open={openDelete}
                setOpen={setOpenDelete}
                select={selectedRow[0]}
                reloading={reloading}
            />
        </>
    );
};
